module.exports = __webpack_public_path__ + "static/media/img-1fff5f1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/synergy-logo.png
// module id = 5302
// module chunks = 39